<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable persistent max-width="400px">
      <v-card class="mx-auto" max-width="400">
        <v-card-title>Black list information</v-card-title>
        <v-divider></v-divider>
        <v-list>
          <v-list-item>
            <v-list-item-title>{{ $t("package.blackList") }}</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-title>Full name</v-list-item-title>
            <v-list-item-subtitle class="text-right text-h3">
            </v-list-item-subtitle>
            <v-list-item-subtitle class="text-right">
              {{ data.full_name }}
            </v-list-item-subtitle>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-title>Number</v-list-item-title>
            <v-list-item-subtitle class="text-right">
              <!-- {{ data.baseCost }}  -->
            </v-list-item-subtitle>
            <v-list-item-subtitle class="text-right">
              {{ data.number }}
            </v-list-item-subtitle>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>Email</v-list-item-title>
            <v-list-item-subtitle class="text-right">
              <!-- {{ data.weightCost }}  -->
            </v-list-item-subtitle>
            <v-list-item-subtitle class="text-right">
              {{ data.email }}
            </v-list-item-subtitle>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>Ban count</v-list-item-title>
            <v-list-item-subtitle class="text-right">
              <!-- {{ data.distanceCost }}  -->
            </v-list-item-subtitle>
            <v-list-item-subtitle class="text-right">
              {{ data.ban_count }}
            </v-list-item-subtitle>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>Reason</v-list-item-title>
            <v-list-item-subtitle class="text-right">
              <!-- {{ data.expressFee }}  -->
            </v-list-item-subtitle>
            <v-list-item-subtitle class="text-right">
              {{ data.reason }}
            </v-list-item-subtitle> </v-list-item
          ><v-list-item>
            <v-list-item-title>comment</v-list-item-title>
            <v-list-item-subtitle class="text-right">
              <!-- {{ data.tax }}  -->
            </v-list-item-subtitle>
            <v-list-item-subtitle class="text-right">
              {{ data.comment }}
            </v-list-item-subtitle>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>Date</v-list-item-title>
            <v-list-item-subtitle class="text-right">
              {{ $subStringDate(data.created_at) }}
            </v-list-item-subtitle>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="close">
            {{ $t("btn.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  props: ["dialog", "data"],
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit("close-dialog");
    },
  },
};
</script>
